module.exports = __webpack_public_path__ + "static/media/temoignages720.3787ff15.mp4";